import React from 'react';
import { AddIconProps } from '..';

const BackIcon: React.FC<AddIconProps> = ({ active = false }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_248_14988)">
        <path
          d="M15 6L9 12L15 18"
          stroke={active ? 'white' : '#1D2129'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_248_14988">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BackIcon;
